define('shared/initializer/form',[
    'shared/lib/RSVP', 
    'shared/initializer/form/submissions/OnSite',
    'shared/initializer/form/submissions/OffSite',
    'shared/initializer/form/submissions/OffSiteAdyen'
], 
function ( 
    RSVP, 
    OnSiteSubmission,
    OffSiteSubmission,
    OffSiteAdyenSubmission
) {

    'use strict';

    return {
        init: function($form, type, options){
            var Submission;

            if (type === 'worldpay') {
                Submission = OffSiteSubmission;
            } else if (type.indexOf('adyen') === 0) {
                Submission = OffSiteAdyenSubmission;
            } else {
                Submission = OnSiteSubmission;
            }

            var submission = new Submission($form, type, options);
            return submission.init();
        }
    };
});

